import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/global.css";
import { loadTranslations } from "./i18n";
import { LensProvider } from "./lens/LensProvider";
import { activeLegacyRedirect } from "./lens/legacyRoutes";

const legacyTarget = activeLegacyRedirect(window.location.hash);
if (legacyTarget) window.history.replaceState(null, "", legacyTarget);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container element not found");
}

const root = createRoot(container);

loadTranslations().finally(() => {
  root.render(<LensProvider><App /></LensProvider>);
});
